export default __webpack_public_path__ + "static/media/avatar_empty.b0498297.svg";